<template functional>
  <h1
    :class="[
      $style.title,
      props.bold && $style.bold,
      props.strong && $style.strong,
      props.heading && $style.heading,
      data.staticClass,
    ]"
    :style="data.staticStyle"
  >
    <slot />

    <div
      v-if="slots().legend"
      :class="$style.legend"
    >
      <slot name="legend" />
    </div>
  </h1>
</template>

<style lang="scss" module>

.title {
  font-size: 2.6rem;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: 1.5px;
  color: #535353;

  &.bold {
    font-weight: bold;
  }

  &.strong {
    color: $color-text;
  }

  &.heading {
    margin-bottom: 50px;
  }
}

.legend {
  font-size: 14px;
  font-weight: 300;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: 0.6px;
  color: $color-text;
  margin-top: 15px;
}

</style>

<script>

export default {
  props: {
    bold: {
      type: Boolean,
      default: false,
    },
    strong: {
      type: Boolean,
      default: false,
    },
    heading: {
      type: Boolean,
      default: true,
    },
    subtitle: {
      type: Boolean,
      default: true,
    },
  },
};
</script>
